import React from "react";
import freedom from '../img/1.jpg';

import {BsInstagram} from 'react-icons/bs';
import {BsTelephone} from 'react-icons/bs';

import './Header.scss';


function  Header() {
    

    return(
        <>
            <div className="header" style={{backgroundImage:`url(${freedom})`, backgroundRepeat: 'no-repeat', backgroundSize:'cover'}}>
                <div className="header__tle">
                    <a className="header__tle-title">
                        FREEDOM
                    </a>
                    <a className="header__tle-subtitle">
                        terrace & lounge
                    </a>
                </div>
                <div className="header__adress">
                    <p className="header__adress-wl">
                        Чекаємо на Вас за адресою:
                    </p>
                    <div className="header__adress-street">
                      <a className="header__adress-street-link" target='_blank' href="https://www.google.com/maps/place/%D0%B2%D1%83%D0%BB%D0%B8%D1%86%D1%8F+%D0%A8%D0%B5%D0%B2%D1%87%D0%B5%D0%BD%D0%BA%D0%B0,+9,+%D0%9A%D1%80%D0%B5%D0%BC%D0%B5%D0%BD%D0%B5%D1%86%D1%8C,+%D0%A2%D0%B5%D1%80%D0%BD%D0%BE%D0%BF%D1%96%D0%BB%D1%8C%D1%81%D1%8C%D0%BA%D0%B0+%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C,+47000/@50.0922044,25.7263796,20.5z/data=!4m6!3m5!1s0x472fc02b258e8f63:0x6d6f41a08cea1f4c!8m2!3d50.0922747!4d25.7266047!16s%2Fg%2F11bbrk2qyl">м. Кременець, вул. Шевченка, 9 (ТРЦ "Diamond Plaza")</a>
                    </div>
                    <p className="header__adress-time">
                    Пн-чт: 10:00-22:00 | Пт-нд: 10:00-23:00
                    </p>
                </div>
                <div className="header__contacts">
                    <div className="header__contacts-inst">
                        <BsTelephone style={{color:"white"}}/>
                        <a className="header__contacts-inst-link" href="tel:0935559303">+380 93 555 93 03</a>
                    </div>
                    <div className="header__contacts-tel">
                        <BsInstagram style={{color:"white"}}/>
                        <a className="header__contacts-tel-link" href="https://www.instagram.com/freedom_kremenets/" target="_blank">@freedom_kremenets</a>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Header;